
import { Button, Flex, Input, Tabs, Upload, Select, Spin, Checkbox, Collapse } from 'antd';
import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { useSelector, useDispatch } from 'react-redux';
import { apiUrls } from '../../apiUrls.js';
import Program from "../../components/Program.js";
import { useNavigate } from 'react-router-dom';
import { UnlockOutlined, LockOutlined, EditOutlined, SearchOutlined } from '@ant-design/icons';
import HideSidebarInMobileMode from "../../components/HideSidebarInMobileMode.js";
import DatePicker, { utils } from '@hassanmojab/react-modern-calendar-datepicker';
import { getMemberAge } from '../../utils/memberAge.js';

const { Option } = Select;

const baseURL = apiUrls.baseURL;

const Total = () => {

    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [loadingMore, setLoadingMore] = useState(false);
    const [hasMore, setHasMore] = useState(true);
    const isFetchingRef = useRef(false);
    const [reload, setReload] = useState(false);
    const [dropDownEducations, setDropDownEducations] = useState([]);
    const [loadingExcel, setLoadingExcel] = useState(false);
    const [startMemberingDate, setStartMemberingDate] = useState(null);
    const [dropDownGenders, setDropDownGenders] = useState([]);
    const [count, setCount] = useState(0);
    const [filter, setFilter] = useState({ skip: 0, limit: 10, data: {} });
    const [dropDownType, setDropDownTypes] = useState([]);
    const [dropDownCertificates, setDropDownCertificates] = useState([]);
    const [dropDownBloodTypes, setDropDownBloodTypes] = useState([]);
    const navigate = useNavigate();

    useEffect(() => {
        fetchMemberTypes()
        fetchCertificates()
        fetchEducations()
        fetchBloodTypes()
        fetchGenders()
    }, [reload])

    useEffect(() => {
        if (filter.skip === 0) setLoading(true);
        else setLoadingMore(true);
        fetchData();
    }, [filter.skip, filter.limit, reload])

    useEffect(() => {
        const loadNextPage = () => {
            const isNearBottom = window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - 200;
            if (isNearBottom && hasMore && !loading && !loadingMore && !isFetchingRef.current) {
                setLoadingMore(true);
                setFilter((current) => ({ ...current, skip: current.skip + 1 }));
            }
        };

        window.addEventListener('scroll', loadNextPage);
        loadNextPage();
        return () => window.removeEventListener('scroll', loadNextPage);
    }, [data, hasMore, loading, loadingMore]);

    const fetchBloodTypes = async () => {
        const token = localStorage.getItem('damavandclub-token')
        try {
            const response = await axios.get(`${baseURL}/user/getBloodTypeDropdownItems`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json',
                }
            })
            var result = response.data.data;
            setDropDownBloodTypes(result);
        } catch (error) {
        } finally {
        }
    };
    const fetchEducations = async () => {
        const token = localStorage.getItem('damavandclub-token')
        try {
            const response = await axios.get(`${baseURL}/user/getEducationLevelDropdownItems`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json',
                }
            })

            var result = response.data.data;
            setDropDownEducations(result);
        } catch (error) {
        } finally {
        }
    };
    const fetchMemberTypes = async () => {
        const token = localStorage.getItem('damavandclub-token')
        try {
            const response = await axios.get(`${baseURL}/user/getTypeDropdownItems`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json',
                }
            })
            var result = response.data.data;
            setDropDownTypes(result)
        } catch (error) {
        } finally {
        }
    };

    const fetchGenders = async () => {
        const token = localStorage.getItem('damavandclub-token')
        try {
            const response = await axios.get(`${baseURL}/user/getGenderDropdownItems`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json',
                }
            })
            var result = response.data.data;
            setDropDownGenders(result);
        } catch (error) {
        } finally {
        }
    };

    const fetchCertificates = async () => {
        const token = localStorage.getItem('damavandclub-token')
        try {
            const response = await axios.get(`${baseURL}/user/getCertificateDropdownItems`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json',
                }
            })

            var result = response.data.data;
            setDropDownCertificates(result);
        } catch (error) {
        } finally {
        }
    }

    const fetchData = async () => {
        isFetchingRef.current = true;
        const token = localStorage.getItem('damavandclub-token')
        try {
            const response = await axios.post(`${baseURL}/user/getmembers`, filter, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json',
                }
            });
            var result = response.data.data;
            result.items.map(item => {
                item.key = item.id
            })
            setCount(result.count)
            setHasMore(result.items.length > 0 && ((filter.skip + 1) * filter.limit < result.count));
            setData((current) => filter.skip === 0 ? result.items : [...current, ...result.items]);
            setLoading(false);

        } catch (error) {
            setHasMore(false);
            if (error.response.status == 401)
                navigate('/');
            setLoading(false);
        } finally {
            isFetchingRef.current = false;
            setLoading(false);
            setLoadingMore(false);
        }
    };

    const getExcel = async () => {

        setLoadingExcel(true)
        const token = localStorage.getItem('damavandclub-token')
        try {
            const response = await axios.post(`${baseURL}/user/getMembersExcelReport`, filter, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                }, 'responseType': 'blob'
            });
            const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            const url = window.URL.createObjectURL(blob);
            window.open(url, '_blank');

            setLoadingExcel(false);
        } catch (error) {
            if (error.response.status == 401)
                navigate('/');
            setLoadingExcel(false);
        } finally {
            setLoadingExcel(false);
        }
    };

    return (
        <div>
            <HideSidebarInMobileMode />
            <Collapse className="members-search-collapse" defaultActiveKey={['0']}>
                <Collapse.Panel header='جستجو ' key='1'>
                    <div className='row'>

                        <div className='col-lg-4 col-sm-12'>

                            {/* <label className='margintop-18'>سال عضویت(ماه و روز اهمیت ندارد)</label> */}
                            <div className='center-content customDatePickerWidth'>
                                <DatePicker
                                    value={startMemberingDate || null}
                                    //inputClassName='fullwidth'
                                    onChange={(value) => {
                                        setStartMemberingDate(value)
                                        setFilter({ ...filter, skip: 0, limit: 10, data: { ...filter.data, startMemberingDate: `${value.year}/${value.month}/${value.day}` } })
                                    }}
                                    //minimumDate={persianToday}
                                    //calendarClassName="fullwidth"
                                    shouldHighlightWeekends
                                    locale='fa'
                                    inputPlaceholder='سال عضویت(ماه و روز اهمیت ندارد)'
                                />
                            </div>

                        </div>

                        <div className='col-lg-4 col-sm-12'>

                            <Select
                                style={{ width: '100%' }}
                                allowClear={true}
                                placeholder="انتخاب نوع عضویت"
                                onChange={(value) => {
                                    setFilter({ ...filter, data: { ...filter.data, type: value } })
                                }}
                                value={data.type}
                            >
                                {dropDownType?.map((item) => (
                                    <Option key={item.id} value={item.id}>
                                        {item.displayName}
                                    </Option>
                                ))}
                            </Select>

                        </div>

                        <div className='col-lg-4 col-sm-12'>
                            <Select
                                showSearch
                                style={{ width: '100%', marginBottom: 5 }}
                                placeholder="انتخاب مدرک"
                                allowClear={true}
                                optionFilterProp="label"
                                notFoundContent="لطفا کمی صبر کنید..."
                                onChange={(value) => {
                                    setFilter({ ...filter, data: { ...filter.data, certificateId: value } })
                                }}
                            >
                                {dropDownCertificates?.map((item) => (
                                    <Option key={item.id} label={item.displayName} value={item.id}>
                                        {item.displayName}
                                    </Option>
                                ))}
                            </Select>
                        </div>
                        <div className='col-lg-4 col-sm-12 margintop-18'>
                            <Select
                                style={{ width: '100%' }}
                                placeholder="انتخاب جنسیت"
                                allowClear={true}
                                onChange={(value) => {
                                    setFilter({ ...filter, data: { ...filter.data, gender: value } })
                                }}
                                value={data.gender}
                            >
                                {dropDownGenders?.map((item) => (
                                    <Option key={item.id} value={item.id}>
                                        {item.displayName}
                                    </Option>
                                ))}
                            </Select>
                        </div>
                        <div className='col-lg-4 col-sm-12 margintop-18'>
                            <Select
                                style={{ width: '100%' }}
                                placeholder="انتخاب سطح تحصیلات"
                                allowClear={true}
                                onChange={(value) => {
                                    setFilter({ ...filter, data: { ...filter.data, educationLevel: value } })
                                }}
                                value={data.educationLevel}
                            >
                                {dropDownEducations?.map((item) => (
                                    <Option key={item.id} value={item.id}>
                                        {item.displayName}
                                    </Option>
                                ))}
                            </Select>
                        </div>
                        <div className='col-lg-4 col-sm-12 margintop-18'>
                            <Select
                                style={{ width: '100%' }}
                                placeholder="انتخاب گروه خونی"
                                allowClear={true}
                                onChange={(value) => {
                                    setFilter({ ...filter, data: { ...filter.data, bloodType: value } })
                                }}
                                value={data.bloodType}
                            >
                                {dropDownBloodTypes?.map((item) => (
                                    <Option key={item.id} value={item.id}>
                                        {item.displayName}
                                    </Option>
                                ))}
                            </Select>
                        </div>
                    </div>

                    <Button className="members-filter-button members-filter-search" onClick={() => {
                        setData([])
                        setFilter((current) => ({ ...current, skip: 0 }))
                        setReload(!reload)
                    }} loading={loading} style={{ marginTop: 10, width: '100%', marginBottom: 10 }}
                        type="primary"><label>جستجو</label></Button>
                    <Button className="members-filter-button members-filter-export" onClick={() => getExcel()} loading={loadingExcel} style={{ marginTop: 10, width: '100%', marginBottom: 10 }}
                        type="primary"><label>خروجی اکسل</label></Button>
                </Collapse.Panel>
            </Collapse>
            <div className="row-container members-list-search-row margintop-5">

                <div className="members-list-search-icon"><SearchOutlined /></div>
                <Input className="members-list-search-input" placeholder='جستجو با نام نام خانوادگی کد ملی عنوان شغلی و شماره عضویت' onKeyDown={(event) => {
                    if (event.key === 'Enter') {
                        setData([])
                        setFilter({ ...filter, skip: 0, limit: 10 })
                        setReload(!reload)
                    }

                }} onChange={(event) => setFilter({ ...filter, search: event.target.value })} style={{ marginTop: 5 }} size="large" />
            </div>


            <div className="members-total-count">
                <span>تعداد کل اعضا</span>
                <strong>{count}</strong>
            </div>
            <div className="member-cards">
                {data.map((record) => (
                    <article key={record.id} className="member-card total-member-card">
                        <div className="member-card-header">
                            {record.profilePhotoUrl ? <a href={record.profilePhotoUrl} target="_blank" rel="noreferrer"><img className="member-card-photo" src={record.profilePhotoUrl} alt={`${record.firstName} ${record.lastName}`} /></a> : <div className="member-card-photo member-card-photo-empty">—</div>}
                            <div className="member-card-name">
                                <strong>{record.firstName} {record.lastName}</strong>
                                {record.isDeaded && <span className="member-card-deceased">مرحوم</span>}
                            </div>
                            <div className={`member-card-account ${record.isActive ? 'member-card-account-active' : 'member-card-account-inactive'}`}>
                                {record.isActive ? <UnlockOutlined /> : <LockOutlined />}
                            </div>
                        </div>
                        <div className="member-card-details">
                            <span>موبایل: {record.phoneNumber || '—'}</span>
                            <span>کد ملی: {record.nationalCode || '—'}</span>
                            {getMemberAge(record.birthDay || record.birthDate) !== null && <span>سن: {getMemberAge(record.birthDay || record.birthDate)}</span>}
                            <span>نوع عضویت: {record.type || '—'}</span>
                            <span>آخرین ورود: {record.lastLoginDate || '—'}</span>
                        </div>
                        <Button className="member-card-details-button" type="link" icon={<EditOutlined />} onClick={() => window.open('/members/detail/' + record.id)}>
                            مشاهده جزئیات
                        </Button>
                    </article>
                ))}
                {(loading || loadingMore) && <div className="member-cards-loading"><Spin /></div>}
                {!loading && data.length === 0 && <div className="member-cards-empty">موردی یافت نشد</div>}
            </div>
        </div>
    )
}

export default Total
